// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftsidebardark .LeftSidebarNav {
  background-color: var(--cardBg);
  box-shadow: none;
}
.leftsidebardark .LeftSidebarNav .black-logo {
  display: none;
}
.leftsidebardark .LeftSidebarNav .white-logo {
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/styles/leftSidebarDark.scss","webpack://./src/styles/leftSidebarDark.css"],"names":[],"mappings":"AACE;EACE,+BAAA;EACA,gBAAA;ACAJ;ADEI;EACE,aAAA;ACAN;ADEI;EACE,qBAAA;ACAN","sourcesContent":[".leftsidebardark {\n  .LeftSidebarNav {\n    background-color: var(--cardBg);\n    box-shadow: none;\n\n    .black-logo {\n      display: none;\n    }\n    .white-logo {\n      display: inline-block;\n    }\n  }\n}\n",".leftsidebardark .LeftSidebarNav {\n  background-color: var(--cardBg);\n  box-shadow: none;\n}\n.leftsidebardark .LeftSidebarNav .black-logo {\n  display: none;\n}\n.leftsidebardark .LeftSidebarNav .white-logo {\n  display: inline-block;\n}/*# sourceMappingURL=leftSidebarDark.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
